import React from 'react';
import { Container } from '@mui/material';
import Navbar from './Navbar';
import Footer from './Footer';

const PrivatumoPolitika = () => {
  return (
    <Container sx={{ mt: 10, mb: 2 }}>
      <div>
        <h1>Privatumo politika</h1>
        <h3>
          Interneto svetainė &nbsp;
          <a
            href='https://mtenisas.lt'
            target='_blank'
            rel='noreferrer noopener'>
            mtenisas.lt
          </a>
          &nbsp; (toliau Teniso Partneris) priklauso ir ją tvarko VšĮ „Teniso
          partneris“ (Duomenų valdytojas) ir asmenys sudarę darbo ar kitokio
          pobūdžio sutartis su ja.
        </h3>
        <br />
        <h4>1. ĮŽANGA</h4>
        <p>
          1.1. Šiame dokumente aptariama Privatumo politika, kuri yra taikoma
          visiems asmenims (toliau Lankytojams), apsilankiusiems &nbsp;
          <a
            href='https://mtenisas.lt'
            target='_blank'
            rel='noreferrer noopener'>
            mtenisas.lt
          </a>
          &nbsp; (toliau Teniso Partneris) svetainėje ar besinaudojantiems jos
          Paslaugomis.
        </p>
        <p>
          1.2. Naudodamasis Teniso Partneris Paslaugomis Lankytojas sutinka su
          šia Privatumo politika. Lankytojas neturi teisės naudotis jokiomis
          Paslaugomis, jeigu nesutinka su šia Privatumo politika.
        </p>
        <p>
          1.3. Privatumo politikoje naudojamos didžiąja raide sąvokos atitinka
          Teniso Partneris svetainės taisyklėse (toliau – Taisyklės) apibrėžtas
          sąvokas ir jų prasmę.
        </p>
        <p>
          1.4. Privatumo politika reglamentuoja Teniso Partneris svetainės ir
          jos Lankytojo pagrindinius asmens duomenų rinkimo, tvarkymo ir
          saugojimo principus bei tvarką.
        </p>
        <p>
          1.5. Lankytojo asmens duomenys renkami ir tvarkomi – Teniso Partneris
          Paslaugų suteikimo ir rinkodaros tikslu.
        </p>
        <br />
        <h4>2. Teniso Partneris RENKAMA INFORMACIJA</h4>
        <p>
          2.1. Teniso Partneris svetainėje Prisijungimo ir Registracijos metu
          yra renkami asmens duomenys (toliau Asmens duomenys) apie Lankytojus.
          Registraciją tam, kad Lankytojas galėtų registruotis į partnerio
          paiešką ar naudotis teikiamomis Paslaugomis. Registracijos metu yra
          sukuriamas Lankytojo profilis. Lankytojas gali bet kuriuo metu
          koreguoti, pildyti ar pareikalauti panaikinti savo Registraciją
          interneto svetainėje, apie tai informuodamas raštu &nbsp;
          <a href='mailto:info@tenisopartneris.lt'>info@tenisopartneris.lt</a>
        </p>
        <p>
          2.2. Lankytojas neprivalo atskleisti jokių asmens duomenų, tačiau
          duomenų neatskleidimas gali apsunkinti Paslaugų teikimą ir (ar)
          naudojimąsi Svetaine, todėl gali būti, kad tokiu atveju Teniso
          Partneris negalės suteikti Paslaugų.
        </p>
        <p>
          2.3. Teniso Partneris turi teisę tvarkyti ir valdyti registracijos
          metu ar vėliau naudojantis Svetaine Lankytojo pateiktus ar kitais
          būdais surinktus asmens duomenis, vadovaujantis šiose Privatumo
          politikoje nustatyta tvarka ir joje nurodytais tikslais. Teniso
          Partneris užtikrina duomenų subjektų teises pagal Asmens duomenų
          teisinės apsaugos įstatymą ir kitus Asmens duomenų tvarkymą
          reglamentuojančius norminius teisės aktus.
        </p>
        <p>
          2.4. Registracija – Asmeninės Informacijos Anketos pildymas.
          Lankytojas Svetainėje pagal poreikį pateikia savo vardą, pavardę,
          telefono numerį, el. pašto adresą. Lankytojui taip pat sudaroma
          galimybė nurodyti ir kitus Asmens duomenis: žaidimo lygį, miestą,
          kuriame gyvena, amžių (viešai galima nerodyti), komentarus, tinkamus
          laikus mačui, ir pan. Lankytojas šiuos duomenis (ne)nurodo savo
          pasirinkimu ir iniciatyva. Lankytojo Asmens duomenys gaunami
          tiesiogiai iš Lankytojo.
        </p>
        <p>
          2.5 Lankytojas pateikia savo Asmens duomenis patalpinimui Svetainėje
          laisva valia ir sutinka, kad jo pateikti duomenys būtų saugomi ir
          tvarkomi elektroniniu duomenų bazėje 2 (dvejus) metus nuo jo
          paskutinio prisijungimo prie sistemos ir suėjus šiam terminui,
          sunaikinami įgalioto darbuotojo.
        </p>
        <p>
          2.6. Pateikdamas asmens duomenis svetainėje lankytojas sutinka ir
          pripažįsta, kad pateikia savo Asmens duomenis tam, kad tretieji
          asmenys galėtų prie šių duomenų prieiti, juos peržiūrėti ir susisiekti
          el. paštu ar nurodytu telefono numeriu.
        </p>
        <p>
          2.7. Lankytojo Asmens duomenys tiesioginei rinkodarai yra renkami ir
          naudojami tik gavus Lankytojo sutikimą šiuos duomenis rinkti ir
          naudoti. Sutikimus dėl tiesioginės rinkodaros gauna tiesiogiai iš
          Lankytojų, jiems aiškiai išreiškus valią (sutikimą) gauti Teniso
          Partneris tiesioginės rinkodaros pasiūlymus, bei iš Lankytojų, duomenų
          rinkimo metu neprieštaravusių dėl tokio asmens duomenų tvarkymo.
          Suteikdamas teisę tvarkyti duomenis tiesioginės rinkodaros tikslais
          Lankytojas taip pat suteikia leidimą susisiekti su juo telefonu, SMS
          žinutėmis, elektroniniu paštu, naujienlaiškiais su tiesioginės
          rinkodaros pasiūlymais.
        </p>
        <p>
          2.8. Lankytojas turi teisę nesutikti, kad jo Asmens duomenys būtų
          tvarkomi tiesioginės rinkodaros tikslais, nenurodydamas nesutikimo
          motyvų. Lankytojas tiesioginės rinkodaros pasiūlymų gali atsisakyti
          tokiais būdais: paspaudęs atitinkamą nuorodą naujienlaiškyje ar el.
          pašto pranešime, informavęs apie nesutikimą Teniso Partneris el.
          laišku &nbsp;
          <a href='mailto:info@tenisopartneris.lt'>info@tenisopartneris.lt</a>
        </p>
        <p>
          2.9. Lankytojas yra informuotas sutinka, kad jam registruojantis
          sistemoje ir prisijungiant prie jos, sistema registruos Lankytojo
          kompiuterio IP adresą ir prisijungimo prie sistemos datą ir laiką.
        </p>
        <p>
          2.10. Teniso Partneris deda visas pastangas, kad Asmens duomenys būtų
          tvarkomi tiksliai, sąžiningai ir teisėtai, tik tokiais tikslais, kurie
          buvo nustatyti prieš renkant asmens duomenis, griežtai laikantis
          teisės aktuose nustatytų asmens duomenų tvarkymo reikalavimų.
        </p>
        <p>
          2.11. Svetainėse gali būti pateikiamos nuorodos į kitas interneto
          svetaines, produktus ir paslaugas, taip pat socialinių tinklų
          plėtinius. Kai kuriose iš tokių interneto svetainių gali būti kaupiama
          Lankytojo asmeninė informacija, o reklaminės interneto svetainės gali
          naudoti slapukus ir kitas panašias priemones savo reklamose, siekdami
          surinkti informaciją apie Lankytoją. Teniso Partneris Privatumo
          politika ir jose išdėstytos nuostatos neapima trečiųjų asmenų taikomos
          privatumo politikos bei nuostatų dėl informacijos rinkimo. Teniso
          Partneris nėra ir nebus laikomas atsakingu už jokius trečiųjų asmenų,
          renkančių informaciją apie Lankytoją, veiksmus.
        </p>
        <br />
        <h4>3. SLAPUKŲ NAUDOJIMAS</h4>
        <p>
          3.1. Daugelis naršyklių yra nustatytos taip, kad automatiškai priimtų
          slapukus. Jeigu Lankytojas nesutinka, kad į jo kompiuterį ar į kitą
          galinį įrenginį būtų įrašomi slapukai, jis gali pakeisti savo
          interneto naršyklės nustatymus ir išjungti visus slapukus arba įjungti
          / išjungti juos po vieną. Kad pašalintų slapukus iš mobiliojo
          įrenginio, Lankytojas turės veikti pagal mobiliojo įrenginio naudojimo
          instrukcijas. Išsamesnė nepriklausoma informacija apie slapukus, jų
          naudojimą, atsisakymo galimybes pateikia adresu &nbsp;
          <a
            href='www.AllAboutCookies.org'
            target='_blank'
            rel='noreferrer noopener'>
            www.AllAboutCookies.org
          </a>{' '}
          &nbsp; arba &nbsp;
          <a
            href='www.google.com/privacy_ads.html'
            target='_blank'
            rel='noreferrer noopener'>
            www.google.com/privacy_ads.html
          </a>
        </p>
        <p>
          3.2. Svetainėje gali būti naudojami techniniai slapukai (būtini
          naršymui Svetainėse ir siekiant naudotis jos pagrindinėmis
          funkcijomis) ir funkciniai slapukai (leidžia įsiminti Lankytojo
          pasirinkimus (tokius, kaip jūsų prisijungimo duomenys) ir pasiūlyti
          patobulintas, Lankytojui pritaikytas funkcijas).
        </p>
        <br />
        <h4>4. LANKYTOJO INFORMACIJOS ŠALINIMAS</h4>
        <p>
          4.1. Lankytojas gali bet kuriuo metu paprašyti panaikinti savo
          paskyrą, ir visą saugomą apie jį informaciją (vardas, pavardė,
          el.paštas). Norint tai padaryti, reikia apie tai informuoti parašydami
          el. laišką adresu &nbsp;
          <a href='mailto:info@tenisopartneris.lt'>info@tenisopartneris.lt</a>
        </p>
        <br />
        <h4>5. INFORMACIJOS APSAUGOS PRIEMONĖS</h4>
        <p>
          5.1. Teniso Partneris naudoja programinę įrangą bei kitokias
          priemones, kuriomis siekiama apsaugoti visų Lankytojų Prisijungimo
          duomenis. Prie Lankytojo Prisijungimo duomenų gali prieiti tik tam
          įgalioti asmenys.
        </p>
        <p>
          5.2. Lankytojas ir pats yra atsakingas už visų Prisijungimo duomenų
          slaptumą ir prašo būti atsargiam naudojant ir saugant Prisijungimo
          duomenis. Lankytojas turėtų atsijungti nuo naršyklės baigęs darbą tam,
          kad būtų tikras, jog niekas neprieis prie Lankytojo elektroninio
          pašto, asmeninės informacijos, ypač tais atvejais, kai Lankytojas
          naudojasi viešai prieinamu kompiuteriu (pvz. interneto kavinėje,
          bibliotekoje ar pan.).
        </p>
        <p>
          5.3. Teniso Partneris įsipareigoja stengtis apsaugoti Lankytojo asmens
          duomenis, kuriuos tvarko, tačiau atsižvelgiant į tai, kad Lankytojo
          informacija yra siunčiama interneto ryšiu, Teniso Partneris įspėja,
          kad negali garantuoti ir negarantuoja jokios Lankytojo perduodamos
          informacijos, įskaitant ir asmeninius duomenis, saugumo.
        </p>
        <p>
          5.4. Teniso Partneris asmeninę Lankytojų informaciją saugo tiek kiek
          reikalinga Taisyklių ir Privatumo politikos nurodytiems tikslams
          įgyvendinti. Lankytojų duomenys yra sunaikinami praėjus 2 (dviem)
          metams nuo jo prisijungimo prie paskyros dienos arba Lankytojui
          panaikinus paskyrą. Teniso Partneris siekia nesaugoti pasenusių ir
          neaktualių Lankytojo asmens duomenų.
        </p>
        <br />
        <h4>6. NEPILNAMEČIŲ APSAUGA</h4>
        <p>
          6.1. Informacijos apie vaikų ir nepilnamečių saugojimą nuo žalingo
          interneto poveikio lankytojas gali rasti adresu &nbsp;
          <a
            href='www.draugiskasinternetas.lt'
            target='_blank'
            rel='noreferrer noopener'>
            www.draugiskasinternetas.lt
          </a>
        </p>
        <p>
          6.2. Teniso Partneris siekia apsaugoti nepilnamečius, besinaudojančius
          Svetaine ir jose teikiamomis Paslaugomis, tačiau neturi jokių
          galimybių apsaugoti tokių asmenų, po to kai jie palieka Svetainę.
        </p>
        <p>
          6.3. Lankytojas taip pat yra atsakingas ne tik už savo, bet ir savo
          nepilnamečių vaikų ar kitų globojamų asmenų elgesį Svetainėje, jei jie
          Svetaine naudojasi Lankytojo aplinkoje, su jo leidimu arba
          naudodamiesi Lankytojo aparatine įranga.
        </p>
        <br />
        <h4>7. ATNAUJINIMAI</h4>
        <p>
          7.1. Teniso Partneris turi teisę bet kada vienašališkai pakeisti
          Privatumo politiką, o tokie pakeitimai įsigalioja po jų paskelbimo
          Svetainėje. Jei Lankytojas po Privatumo politikos pakeitimų paskelbimo
          naudojasi Svetaine ir (ar) Paslaugomis, laikoma, kad jis sutinka su
          visais pakeitimais. Lankytojui nesutinkant su pakeistu Privatumo
          politikos turiniu, jis praranda teisę naudotis Teniso Partneris
          svetaine, o taip pat privalo nedelsiant panaikinti savo registraciją
          Svetainėje.
        </p>
        <br />
        <h4>8. SUSISIEKITE SU MUMIS</h4>
        <p>
          Visi klausimai dėl Privatumo politikos &nbsp;
          <a href='mailto:info@tenisopartneris.lt'>info@tenisopartneris.lt</a>
        </p>
      </div>
    </Container>
  );
};

export default PrivatumoPolitika;
